import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQuery } from 'shared/api/rtk-query';
import { IContacts, ILinkedUrl, ILinkedPhone, ILinkedEmail, AddContactDto } from '@sr/dto';
import { AddContactQuery, ContactQuery, DeleteContactQuery } from './contacts.types';
import { buildAddContactUrl, buildDeleteContactsUrl, buildGetContactsUrl } from './contact.helpers';
import { contactDupesApi } from 'entities/contact-dupes/api.slice';

const CONTACTS_BASE_PATH = '/contacts';
type AddContactParams = { query: AddContactQuery; data: AddContactDto };

export const contactsApi = createApi({
  reducerPath: 'contacts',
  baseQuery: createBaseQuery(),
  endpoints: (builder) => ({
    getContacts: builder.query<IContacts, ContactQuery>({
      query: (query: ContactQuery) => ({
        url: `${CONTACTS_BASE_PATH}/${buildGetContactsUrl(query)}`,
        method: 'GET',
      }),
      providesTags: (result, error, query, meta) => (result ? [{ type: 'Contacts', id: buildGetContactsUrl(query) }] : ['Contacts']),
    }),
    addContact: builder.mutation<ILinkedPhone | ILinkedEmail | ILinkedUrl, AddContactParams>({
      query: ({ data, query }: AddContactParams) => ({
        url: `${CONTACTS_BASE_PATH}/${buildAddContactUrl(query)}`,
        body: data,
        method: 'POST',
      }),
      async onQueryStarted({ query }, { dispatch, queryFulfilled }) {
        try {
          const { data: contact } = await queryFulfilled;
          if ('phone' in contact) dispatch(contactDupesApi.util.invalidateTags([{ type: 'dupes', id: contact.phone }]));
          const { relationId, relationType } = query;
          dispatch(
            contactsApi.util.updateQueryData('getContacts', { relationId, relationType }, (contacts) => {
              if ('phone' in contact) {
                if (!contacts.linkedPhones.some((item) => item.id === contact.id)) contacts.linkedPhones.push(contact);
              } else if ('email' in contact) {
                if (!contacts.linkedEmails.some((item) => item.id === contact.id)) contacts.linkedEmails.push(contact);
              } else if ('url' in contact) {
                if (!contacts.linkedUrls.some((item) => item.id === contact.id)) contacts.linkedUrls.push(contact);
              }
            }),
          );
        } catch (error) {
          console.error('Ошибка добавления контакта:', error);
        }
      },
      invalidatesTags: (result, error, { query }) => [{ type: 'Contacts', id: buildGetContactsUrl(query) }],
    }),
    deleteContact: builder.mutation<void, DeleteContactQuery>({
      query: (query: DeleteContactQuery) => ({
        url: `${CONTACTS_BASE_PATH}/${buildDeleteContactsUrl(query)}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, query) => [{ type: 'Contacts', id: buildGetContactsUrl(query) }],
    }),
  }),
  tagTypes: ['Contacts'],
});
